/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import Backbone from 'backbone';
import $ from 'jquery';
import React from 'react';
import ReactDOMServer from 'react-dom/server';
import _ from 'underscore';

import EditPrimerTabState from 'analyses/EditPrimerTabState';
import {FindPrimersTabState} from 'molbio/find-primers/FindPrimersTabState';
import PrimerWizardTabState from 'analyses/primers/PrimerWizardTabState';
import * as analytics from 'analytics/Analytics';
import asm from 'assembly/Asm';
import {assertAndContinue} from 'Asserts';
import * as biojs from 'BioJS';
import {canCreatePrimerPair, createPrimerPair} from 'molbio/primers/PrimerUtil';
import {ANALYTICS_MODULE} from 'constants/AnalyticsConstants';
import * as util from 'biojs/Util';
import MeltingTempModal from 'molbio/melting-temp/MeltingTempModal';
import runConfirmDeleteModal from 'ui-library/modals/runConfirmDeleteModal';
import {blastPrimer} from 'molbio/ExternalLib';
import FileStates from 'FileStates';
import notifications from 'notifications';
import preferences from 'Preferences';
import {renderToDOM} from 'redux-stores/ReduxDOMRender';
import LinksInformationTemplate from 'toolbar/primer-panel/LinksInformationTemplate';
import LinksRowTemplate from 'toolbar/primer-panel/LinksRowTemplate';
import PrimerTable from 'toolbar/primer-panel/PrimerTable';
import PrimerInformationTemplate from 'toolbar/primer-panel/PrimerInformationTemplate';
import {renderPanelTabs} from 'toolbar/shared/PanelUtil';
import {SEQUENCE_PRIMER_PANEL_PRIMERS, SEQUENCE_PRIMER_PANEL_PAIRS} from 'toolbar/ToolbarConstants';
import runModal from 'ui-library/runModal';
import * as sequtil from 'molbio/SeqUtil';
import ToolbarSignupMessage from 'nav/share/growth/ToolbarSignupMessage';
import {showValueMessagingForSharedFile} from 'nav/share/growth/Util';

import {PrimerPreferences} from 'constants/PrimerConstants';
import {SequenceType} from 'constants/SequenceConstants';
import {getPrimerTableProps} from './PrimerTablePropsHelpers';

class InsertBase extends Backbone.View {
  insert(tab) {
    this.panelState.get('buffers').addTab(tab);
    return this.panelState.trigger('close');
  }
}

class PrimerInfoView extends InsertBase {
  static initClass() {
    this.prototype.template = (allowFeatureEdits) =>
      ReactDOMServer.renderToStaticMarkup(
        <PrimerInformationTemplate allowFeatureEdits={allowFeatureEdits} />
      );

    this.prototype.events = {
      'click .detach-primer': 'deleteActivePrimer',
      'click .adjust-tm': 'adjustMeltingTemperature',
      'click .secondary-analyze': 'analyzeSecondary',
      'click .other-binding': 'findOtherBinding',
      'click .edit-primer': 'editPrimer',
      'click .blast-primer': 'blastPrimer',
    };
  }

  deleteActivePrimer() {
    return this.panelState.trigger('deleteActive');
  }

  findOtherBinding() {
    FindPrimersTabState.insert(this.sequence, {findType: 2}, this.selectedPrimer.get('_primer'));
    return this.panelState.trigger('close');
  }

  analyzeSecondary() {
    EditPrimerTabState.edit(this.selectedPrimer.get('_primer'), this.sequence, true);
    return this.panelState.trigger('close');
  }

  blastPrimer() {
    return blastPrimer(this.selectedPrimer);
  }

  adjustMeltingTemperature() {
    runModal(MeltingTempModal, {});
  }

  editPrimer() {
    EditPrimerTabState.edit(this.selectedPrimer.get('_primer'), this.sequence);
    return this.panelState.trigger('close');
  }

  render() {
    if (this.selectedPrimer == null || this.selectedPrimer.isNew()) {
      this.$el.hide();
      this.panelState.trigger('resize');
      return this;
    }
    this.$el.show();

    const bindingBases = this.selectedPrimer.bindingBases();

    this.$('.name').text(this.selectedPrimer.name());
    const _primer = this.selectedPrimer.get('_primer');
    if (_primer.get('folder') != null) {
      this.$('.library').click(() => {
        FileStates.get().openFolder(_primer.get('folder_api_id'), _primer.get('folder_url'));
      });
      this.$('.library').text(`${_primer.get('owner')}/${_primer.get('folder')}`);
    } else {
      this.$('.library').text('None').addClass('disabled');
    }

    this.$('.sequence-primer-bases-inner').html(this.selectedPrimer.basesHtml(this.sequence));
    this.$('.length').text(this.selectedPrimer.bases().length);
    this.$('.gc').text(`${(util.gc(bindingBases, this.selectedPrimer.nucleotideType()) * 100).toFixed(1)}%`);
    this.$('.melting-temp').text(this.selectedPrimer.displayMeltingTemperature());

    const allowFeatureEdits = this.sequence.allowFeatureEdits() && this.selectedPrimer.editable();
    this.$('.edit-primer').toggleClass('hidden', !allowFeatureEdits);
    this.$('.js-detach').toggleClass(
      'hidden',
      !allowFeatureEdits ||
        _primer.get('folder_api_id') == null ||
        asm.of(this.sequence._sequence()).isFlankingPrimer(this.sequence._sequence(), this.selectedPrimer)
    );

    this.updateColor();
    this.panelState.trigger('resize');
    return this;
  }

  updatePrimerListeners() {
    if (this.selectedPrimer != null) {
      this.stopListening(this.selectedPrimer.get('_primer'));
    }
    this.selectedPrimer = this.sequence.sequencePrimers().findWhere({active: true});
    this.render();
    this.allowSpecificityCheck();
    if (this.selectedPrimer) {
      this.listenTo(
        this.selectedPrimer.get('_primer'),
        'change:bases',
        // eslint-disable-next-line no-restricted-syntax
        _.bind(this.update, this, this.panelState, this.sequence)
      );
      this.listenTo(this.selectedPrimer.get('_primer'), 'change:name', function (_primer) {
        return this.$el.find('.name').text(_primer.get('name'));
      });
      this.listenTo(this.selectedPrimer.get('_primer'), 'change:color', this.updateColor);
      this.listenTo(this.selectedPrimer.get('_primer'), 'change:nucleotideType', this.allowSpecificityCheck);
    }
  }

  updateColor() {
    return this.$el
      .find('.swatch-big')
      .css('background-color', this.selectedPrimer.color())
      .toggleClass('disabled', !this.sequence.allowFeatureEdits());
  }

  allowSpecificityCheck() {
    if (!this.sequence.get('currentVersion')) {
      return this.$el.find('.other-binding').addClass('disabled').tooltip({
        placement: 'left',
        title: 'Specificity cannot be checked when on a historical version. (Feedback welcome.)',
      });
    } else {
      return this.$el.find('.other-binding').removeClass('disabled').tooltip('destroy');
    }
  }

  update(panelState, sequence) {
    if (this.panelState != null) {
      this.stopListening(this.panelState);
    }
    this.panelState = panelState;

    this.stopListening(preferences);
    this.listenTo(
      preferences,
      `change:${PrimerPreferences.MELTING_TEMP_DNA} change:${PrimerPreferences.MELTING_TEMP_RNA}`,
      this.render
    );

    if (this.sequence != null) {
      this.stopListening(this.sequence);
    }
    this.sequence = sequence;
    // When reset, change:selected doesn't get hit so we need to check if selected primer has changed.
    this.listenTo(this.sequence.sequencePrimers(), 'change:active reset', this.updatePrimerListeners);
    this.$el.html(this.template(this.sequence.allowFeatureEdits()));
    this.allowSpecificityCheck();
    this.listenTo(this.sequence, 'change:currentVersion', this.allowSpecificityCheck);
    this.updatePrimerListeners();
    return this.render();
  }
}
PrimerInfoView.initClass();

class LinksRowView extends Backbone.View {
  static initClass() {
    this.prototype.template = LinksRowTemplate;
    this.prototype.tagName = 'tbody';
    this.prototype.events = {click: 'makeSelection'};
  }

  initialize({collection, sequence}) {
    this.collection = collection;
    this.sequence = sequence;
    this.listenTo(this.sequence.selection(), 'change', this.toggleSelected);
  }

  makeSelection() {
    const selection = this.sequence.selection();
    const [primerFwd, primerRev] = Array.from(this.model.getPrimers(this.collection));
    return selection.selectPair(primerFwd, primerRev);
  }

  toggleSelected() {
    const [primerFwd, primerRev] = Array.from(this.model.getPrimers(this.collection));
    const selection = this.sequence.selection();
    const selected =
      selection.getStartState('primer') === primerFwd && selection.getEndState('primer') === primerRev;
    return this.$el.find('tr').toggleClass('active', selected);
  }

  render() {
    const [primerFwd, primerRev] = Array.from(this.model.getPrimers(this.collection));
    this.$el.html(
      this.template({
        sequence: this.sequence.get('_sequence'),
        primerFwd,
        primerRev,
        productLength: this.model.productLength(
          this.collection,
          this.sequence.circular(),
          this.sequence.length()
        ),
        sequtil,
      })
    );
    this.toggleSelected();
    return this;
  }
}
LinksRowView.initClass();

class LinksInformationView extends Backbone.View {
  static initClass() {
    this.prototype.template = LinksInformationTemplate;
    this.prototype.events = {
      'click .unlink-primers': 'destroyPair',
      'click .edit-pair': 'editPair',
      'click .create-sequence': 'createSequence',
      'click .check-secondary': 'checkSecondary',
    };
  }

  destroyPair() {
    const pair = this.existingPair;

    function done() {
      notifications.success('Primers successfully unlinked.');
      this.sequence.updateVersions();
      this.render();
      return analytics.track('primer', 'unlinked_primers', {
        forward_primer_id: pair.forwardPrimerId(),
        reverse_primer_id: pair.reversePrimerId(),
        sequence_id: this.sequence.get('id'),
      });
    }

    return pair
      .destroy({wait: true})
      .fail(notifications.notifyError) // eslint-disable-next-line no-restricted-syntax
      .done(_.bind(done, this));
  }

  createSequence() {
    analytics.track('primer', 'create_sequence', {sequence_id: this.sequence.get('id')});
    return this.sequence.handleCreateFromSelectionClick(
      this.sequence.type(),
      this.sequence.type() === SequenceType.SINGLE_STRANDED ? 1 : null
    );
  }

  checkSecondary() {
    const [fwd, rev] = Array.from(
      this.existingPair.getPrimers(this.sequence.get('_sequence').sequencePrimers())
    );
    EditPrimerTabState.editPair(fwd, rev, this.sequence, true);
    return this.panelState.trigger('close');
  }

  editPair() {
    const [fwd, rev] = Array.from(
      this.existingPair.getPrimers(this.sequence.get('_sequence').sequencePrimers())
    );
    EditPrimerTabState.editPair(fwd, rev, this.sequence);
    return this.panelState.trigger('close');
  }

  render() {
    this.existingPair = null;
    if (this.selection.canPCR()) {
      let forwardPrimer = this.selection.getStartState('primer');
      let reversePrimer = this.selection.getEndState('primer');
      assertAndContinue(
        forwardPrimer.strand() === -reversePrimer.strand(),
        `Primers ${forwardPrimer.name()} and ${reversePrimer.name()} selected and canPCR(), but different strands!`
      );
      if (forwardPrimer.strand() === -1) {
        reversePrimer = forwardPrimer;
        forwardPrimer = reversePrimer;
      }
      const forwardTm = forwardPrimer.get('_primer').meltingTemperature();
      const reverseTm = reversePrimer.get('_primer').meltingTemperature();
      const tmDiff = reverseTm - forwardTm;
      const attrs = {primer_fwd_id: forwardPrimer.id, primer_rev_id: reversePrimer.id};

      this.existingPair =
        this.pairs.findWhere(attrs) ||
        new biojs.PrimerPair(attrs, {
          primers: this.primers,
        });
      const productLength = this.existingPair.productLength(
        this.primers,
        this.sequence.circular(),
        this.sequence.length()
      );
      let allowUnlink = true;
      if (this.existingPair != null && !this.sequence.finalized()) {
        const fragmentResult = this.sequence
          .fragmentResults()
          .find((fr) => fr.primerPairID() === this.existingPair.id);
        allowUnlink = fragmentResult == null;
      }
      if (this.existingPair != null && (forwardPrimer.fromSubPart() || reversePrimer.fromSubPart())) {
        allowUnlink = false;
      }
      this.$el.html(
        this.template({
          forward: {
            name: forwardPrimer.name(),
            tm: forwardTm,
          },
          reverse: {
            name: reversePrimer.name(),
            tm: reverseTm,
          },
          tmDiff: tmDiff > 0 ? `+${tmDiff.toFixed(1)}` : tmDiff.toFixed(1),
          productLength,
          existing: !this.existingPair.isNew(),
          linkable:
            this.existingPair != null &&
            this.sequence.allowFeatureEdits() &&
            !forwardPrimer.fromSubPart() &&
            !reversePrimer.fromSubPart(),
          allowFeatureEdits: this.sequence.allowFeatureEdits(),
          allowUnlink,
        })
      );
      this.$('.link-primers').toggleClass('disabled', !this.existingPair.isNew());
    }
    this.$el.toggleClass('hidden', !this.selection.canPCR());
    this.panelState.trigger('resize');
    return this;
  }

  update(panelState, sequence) {
    this.panelState = panelState;
    this.sequence = sequence;
    this.primers = this.sequence.sequencePrimers();

    if (this.pairs != null) {
      this.stopListening(this.pairs);
    }
    this.pairs = this.sequence.get('_sequence').primerPairs();
    this.listenTo(this.pairs, 'change:id', this.render);

    if (this.selection != null) {
      this.stopListening(this.selection);
    }
    this.selection = this.sequence.selection();
    this.listenTo(this.selection, 'change', this.render);

    return this.render();
  }
}
LinksInformationView.initClass();

class LinksView extends Backbone.View {
  initialize() {
    this.infoView = new LinksInformationView({el: this.$el.find('.link-info')});
    return this.infoView;
  }

  render() {
    let view;
    if (this.rowViews != null) {
      for (view of Array.from(this.rowViews)) {
        view.remove();
      }
    }
    this.rowViews = Array.from(this.pairs.models).map((pair) =>
      new LinksRowView({model: pair, collection: this.primers, sequence: this.sequence}).render()
    );
    const els = (() => {
      const result = [];
      for (view of Array.from(this.rowViews)) {
        result.push(view.el);
      }
      return result;
    })();
    this.$el.find('.primer-links-table').find('tbody').remove();
    if (els.length > 0) {
      this.$el.find('.primer-links-table').append(els);
    } else {
      const $empty = $('<tr>').append($('<td colspan="3">').html('No linked primers attached to sequence'));
      this.$el.find('.primer-links-table').append($('<tbody>').append($empty));
    }
    return this;
  }

  update(panelState, sequence) {
    if (this.primers != null) {
      this.stopListening(this.primers);
    }
    if (this.sequence != null) {
      this.stopListening(this.sequence.get('_sequence'));
    }

    this.sequence = sequence;

    this.primers = sequence.sequencePrimers();

    const listenToPairs = (render) => {
      if (this.pairs != null) {
        this.stopListening(this.pairs);
      }
      this.pairs = sequence.get('_sequence').primerPairs();
      this.listenTo(this.pairs, 'add remove reset', this.render);
      if (render) {
        this.render();
      }
    };
    this.listenTo(sequence.get('_sequence'), 'change:primerPairs', () => listenToPairs(true));
    listenToPairs(false);

    this.infoView.update(panelState, sequence);
    return this.render();
  }
}

class PrimerPanelView extends InsertBase {
  static initClass() {
    this.prototype.el = '#primer-panel';
    this.prototype.events = {
      'click .primers-title': 'showPrimers',
      'click .links-title': 'showLinks',
      'click .create-manual': 'createPrimer',
      'click .create-wizard': 'generatePrimers',
      'click .js-attach-existing': 'searchPrimers',
      'click .link-primers': 'linkPrimers',
      'click .js-detach-all-primers': 'deleteAllPrimers',
      'click .create-primers': 'trackCreatePrimers',
    };
  }

  initialize() {
    this.infoView = new PrimerInfoView({el: this.$el.find('.additional-primer-info')});
    this.linkView = new LinksView({el: this.$el.find('.links-subpanel .panel-container')});
    return this.linkView;
  }

  trackCreatePrimers() {
    analytics.track('primer', 'create_primers_clicked', {
      product: ANALYTICS_MODULE.MOLBIO,
      sequence_id: this.sequence.get('id'),
    });
  }

  showSubPanel() {
    const panel = this.panelState.get('activeSubPanel');
    renderPanelTabs(
      this.panelState,
      [
        [SEQUENCE_PRIMER_PANEL_PRIMERS, 'Primers'],
        [SEQUENCE_PRIMER_PANEL_PAIRS, 'Pairs'],
      ],
      this.$('.panel-title')[0]
    );
    this.$el.find('h4[class*="-title"]').parent().removeClass('active');
    this.$el.find(`.${panel}-title`).parent().addClass('active');
    this.$el.find('.panel-container').parent().hide();
    this.$el.find(`.${panel}-subpanel`).show();
    this.$el.find('.panel-content').scrollTop(0);
    this.panelState.trigger('resize');
  }

  showPrimers() {
    return this.panelState.set('activeSubPanel', SEQUENCE_PRIMER_PANEL_PRIMERS);
  }

  showLinks() {
    return this.panelState.set('activeSubPanel', SEQUENCE_PRIMER_PANEL_PAIRS);
  }

  createPrimer(e) {
    e.preventDefault();
    this.insert(new EditPrimerTabState({sequence: this.sequence}));
    analytics.track('primer', 'open_edit_primer_tab', {
      product: ANALYTICS_MODULE.MOLBIO,
      createdFrom: 'toolbar',
      direction: null,
      sequence_id: this.sequence.get('id'),
    });
  }

  generatePrimers(e) {
    e.preventDefault();
    const tab = new PrimerWizardTabState({sequence: this.sequence, buffers: this.panelState.get('buffers')});
    this.insert(tab);
    analytics.track('primer', 'open_primer_wizard', {
      product: ANALYTICS_MODULE.MOLBIO,
      sequence_id: this.sequence.get('id'),
    });
  }

  searchPrimers() {
    analytics.track('primer', 'attach_existing_click', {
      product: ANALYTICS_MODULE.MOLBIO,
      sequence_id: this.sequence.get('id'),
    });
    FindPrimersTabState.insert(this.sequence, {findType: 1});
    return this.panelState.trigger('close');
  }

  upsert(tab) {
    const buffers = this.panelState.get('buffers');
    const existingTab = buffers.getTab((t) => t.get('title') === tab.get('title'));

    if (existingTab != null) {
      existingTab.set({active: true});
    } else {
      buffers.addTab(tab);
    }
    return this.panelState.trigger('close');
  }

  linkPrimers() {
    this.$('.link-primers').button('loading');
    createPrimerPair(this.sequence, () => {
      this.$('.link-primers').button('reset');
      // Must `defer` - https://github.com/twbs/bootstrap/issues/6242
      _.defer(() => this.renderLinkButton());
    });
  }

  async deleteAllPrimers() {
    if (!this.sequence.allowFeatureEdits()) {
      return;
    }
    if (
      await runConfirmDeleteModal({
        typeName: 'primers',
        message: 'Are you sure you want to remove all primers from the sequence?',
      })
    ) {
      analytics.track('primer', 'deleted_all_primers', {sequence_id: this.sequence.get('id')});
      const primerCollection = this.sequence._primers;
      const [subPartPrimers, nonPartPrimers] = Array.from(
        _.partition(primerCollection.models, (model) => model.fromSubPart())
      );
      const [unsavedPrimers, savedPrimers] = Array.from(
        _.partition(nonPartPrimers, (model) => model.isNew())
      );

      if (subPartPrimers.length && !nonPartPrimers.length) {
        notifications.warn('Primers that belong to sequence parts must be detached from that part.');
        return;
      }
      const deleteSavedPrimers = savedPrimers.length
        ? primerCollection.bulkDelete(savedPrimers, {fileUpdate: true}).fail(notifications.notifyError)
        : null;
      $.when(deleteSavedPrimers).done(() => {
        primerCollection.remove(unsavedPrimers);
        if (!subPartPrimers.length) {
          notifications.success('All primers detached successfully.');
        } else {
          notifications.success('All non-part primers detached successfully.');
        }
      });
    }
  }

  deleteActivePrimer() {
    const activePrimer = this.primers.findWhere({active: true});
    if (activePrimer == null) {
      return;
    }
    let oldIndex = 0;
    for (let i = 0; i < this.primers.models.length; i++) {
      const sequencePrimer = this.primers.models[i];
      if (sequencePrimer.id === activePrimer.id) {
        oldIndex = i;
        break;
      }
    }
    activePrimer
      .destroy()
      .done(() => {
        analytics.track('primer', 'deleted_primer', {sequence_id: this.sequence.get('id')});
        const newIndex = Math.min(oldIndex, this.primers.length - 1);
        if (newIndex >= 0) {
          this.primers.at(newIndex).set({active: true});
        }
        notifications.success(
          <>
            Primer <strong>{activePrimer.name()}</strong> detached successfully.
          </>
        );

        this.renderLibrary();
        this.sequence.updateVersions();
      })
      .fail(notifications.notifyError);
  }

  addLibraryListeners() {
    const sequence = this.sequence;
    this.listenTo(
      preferences,
      `change:${PrimerPreferences.MELTING_TEMP_DNA} change:${PrimerPreferences.MELTING_TEMP_RNA}`,
      this.renderLibrary
    );
    // TODO add startindex to synced attrs
    this.listenTo(sequence._sequence(), 'change:startIndex', this.renderLibrary);
  }

  renderLibrary() {
    assertAndContinue(
      this.sequence.sequencePrimers() === this.primers,
      'Primers out of sync with sequence.sequencePrimers'
    );

    const primerProps = getPrimerTableProps(this.sequence);
    renderToDOM(<PrimerTable {...primerProps} />, this.$el.find('.primers-table-container').get(0));

    this.$('.js-detach-all-primers-section').toggleClass('hidden', !this.primers.length);
  }

  renderLinkButton() {
    return this.$('.link-primers').toggleClass('disabled', !canCreatePrimerPair(this.sequence));
  }

  _updateListener(reference, replacement) {
    if (this[reference] != null) {
      this.stopListening(this[reference]);
    }
    this[reference] = replacement;
  }

  render() {
    this.showSubPanel();

    this.renderLibrary();
    this.addLibraryListeners();

    this.renderLinkButton();
    this.$('.js-disable-readonly .btn').toggleClass('disabled', !this.sequence.allowFeatureEdits());

    if (showValueMessagingForSharedFile()) {
      this.$('.js-hide-for-share-link').addClass('hide');

      renderToDOM(
        <ToolbarSignupMessage action="add a primer" />,
        this.$el.find('.share-link-message-react-mount')[0]
      );
    } else if (!this.sequence.allowFeatureEdits()) {
      this.$('.js-disable-readonly').tooltip({
        title: 'Enabled on writable sequences only',
        placement: 'bottom',
        container: 'body',
      });
      this.$('.js-detach-all-primers').addClass('disabled');
    } else {
      this.$('.js-disable-readonly').tooltip('destroy');
    }
    this.$('.link-primers').toggleClass('hidden', !this.sequence.allowFeatureEdits());

    return this;
  }

  update(panelState, sequence) {
    this._updateListener('panelState', panelState);
    this.listenTo(this.panelState, 'change:activeSubPanel', this.showSubPanel);
    this.listenTo(this.panelState, 'deleteActive', this.deleteActivePrimer);
    this._updateListener('sequence', sequence);
    this._updateListener('primers', sequence.sequencePrimers());
    this._updateListener('pairs', sequence.primerPairs());
    this.listenTo(this.primers, 'change remove add reset saved', this.render);
    this.listenTo(
      this.primers,
      'change:strand change:nucleotideType change:fromSubPart change:selected',
      this.renderLinkButton
    );
    this.listenTo(this.pairs, 'remove add reset saved', this.renderLinkButton);

    this.infoView.update(panelState, sequence);
    this.linkView.update(panelState, sequence);

    this.$('.js-detach-all-primers').toggleClass('disabled', !this.sequence.get('_sequence').finalized());
    return this.render();
  }
}
PrimerPanelView.initClass();

export default PrimerPanelView;
